import { render, staticRenderFns } from "./external-modal.vue?vue&type=template&id=522001b0&scoped=true&"
import script from "./external-modal.vue?vue&type=script&lang=ts&"
export * from "./external-modal.vue?vue&type=script&lang=ts&"
import style0 from "./external-modal.vue?vue&type=style&index=0&id=522001b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522001b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDialog,VIcon})
